(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diet-content-img"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sliderEl = document.querySelector('[data-mobile-slider]');
  let splideInstance = null;

  function initSlider() {
    if (!sliderEl) return;

    if (window.innerWidth <= 768) {
      if (!splideInstance) {
        sliderEl.classList.add('splide');
        const grid = sliderEl.querySelector('.diets-cards');
        grid.classList.add('splide__list');
        grid.querySelectorAll('.diet-card').forEach(el => el.classList.add('splide__slide'));

        if (!sliderEl.querySelector('.splide__track')) {
          const track = document.createElement('div');
          track.className = 'splide__track';
          sliderEl.insertBefore(track, grid);
          track.appendChild(grid);
        }

         splideInstance = new Splide(sliderEl, {
        type: 'loop',
        perPage: 1.6,
        perMove: 1,          // ensure consistent movement
        gap: '1rem',
        pagination: true,
        arrows: false,
        clones: 3,           // increase clone count
        rewind: false,       // don’t force jump back
        drag: true,
      });

        splideInstance.mount();
      }
    } else {
      if (splideInstance) {
        splideInstance.destroy(true);
        splideInstance = null;

        sliderEl.classList.remove('splide');
        const grid = sliderEl.querySelector('.diets-cards');
        grid.classList.remove('splide__list');
        grid.querySelectorAll('.diet-card').forEach(el => el.classList.remove('splide__slide'));

        const track = sliderEl.querySelector('.splide__track');
        if (track) {
          sliderEl.appendChild(grid);
          track.remove();
        }
      }
    }
  }

  initSlider();
  window.addEventListener('resize', initSlider);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meal-how-its-work"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('[data-mobile-slider]');
    let splideInstance = null;

    function initSlider() {
      if (window.innerWidth <= 768) {
        if (!splideInstance) {
          sliderEl.classList.add('splide');
          const grid = sliderEl.querySelector('.hiw-grid');
          grid.classList.add('splide__list');
          grid.querySelectorAll('.hiw-card').forEach((el) => el.classList.add('splide__slide'));

          if (!sliderEl.querySelector('.splide__track')) {
            const track = document.createElement('div');
            track.className = 'splide__track';
            sliderEl.insertBefore(track, grid);
            track.appendChild(grid);
          }

          splideInstance = new Splide(sliderEl, {
            type: 'loop',
            perPage: 1.6,
            perMove: 1, 
            gap: '1rem',
            pagination: true,
            arrows: false,
            clones: 3, 
            rewind: false, 
            drag: true,
          });

          splideInstance.mount();
        }
      } else {
        if (splideInstance) {
          splideInstance.destroy(true);
          splideInstance = null;

          sliderEl.classList.remove('splide');
          const grid = sliderEl.querySelector('.hiw-grid');
          grid.classList.remove('splide__list');
          grid.querySelectorAll('.hiw-card').forEach((el) => el.classList.remove('splide__slide'));
          const track = sliderEl.querySelector('.splide__track');
          if (track) {
            sliderEl.appendChild(grid);
            track.remove();
          }
        }
      }
    }

    initSlider();
    window.addEventListener('resize', initSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-testimonial"] && !Shopify.designMode) return;
  try {
    
let splideInitialized = false;

function initSplideSlider() {
  if (window.innerWidth <= 1161 && !splideInitialized) {
    splideInitialized = true;
    new Splide('#testimonial-slider', {
      type: 'loop',
      perPage: 1.5,
      focus: 'left',
      gap: '20px',
      autoplay: true,
      interval: 3000,
      pagination: true,
      arrows: false,
      breakpoints: {
        767: {
          perPage: 1,
          gap: '16px'
        }
      }
    }).mount();
  }
}

document.addEventListener('DOMContentLoaded', initSplideSlider);
window.addEventListener('resize', initSplideSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-parameter-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderEl = document.querySelector('[data-mobile-slider2]');
    let splideInstance = null;

    function initSlider() {
      if (!sliderEl) return;

      if (window.innerWidth <= 768) {
        if (!splideInstance) {
          sliderEl.classList.add('splide');
          const grid = sliderEl.querySelector('.mainbx-card');
          grid.classList.add('splide__list');
          grid.querySelectorAll('.bx-item').forEach((el) => el.classList.add('splide__slide'));

          if (!sliderEl.querySelector('.splide__track')) {
            const track = document.createElement('div');
            track.className = 'splide__track';
            sliderEl.insertBefore(track, grid);
            track.appendChild(grid);
          }

          splideInstance = new Splide(sliderEl, {
            type: 'loop',
            perPage: 1.2,
            perMove: 1, // ensure consistent movement
            gap: '1rem',
            pagination: true,
            arrows: true,
            clones: 3, // increase clone count
            rewind: false, // don’t force jump back
            drag: true,
          });

          splideInstance.mount();
        }
      } else {
        if (splideInstance) {
          splideInstance.destroy(true);
          splideInstance = null;

          sliderEl.classList.remove('splide');
          const grid = sliderEl.querySelector('.mainbx-card');
          grid.classList.remove('splide__list');
          grid.querySelectorAll('.bx-item').forEach((el) => el.classList.remove('splide__slide'));

          const track = sliderEl.querySelector('.splide__track');
          if (track) {
            sliderEl.appendChild(grid);
            track.remove();
          }
        }
      }
    }

    initSlider();
    window.addEventListener('resize', initSlider);
  });

  } catch(e) { console.error(e); }
})();
})();
